export const dummydata = [
  {
    month: "Jan",
    uv: 4000,
    pv: 2400,
    amt: 5400,
  },
  {
    month: "Feb",
    uv: 13000,
    pv: 1398,
    amt: 13210,
  },
  {
    month: "Mar",
    uv: 20000,
    pv: 9800,
    amt: 15290,
  },
  {
    month: "Apr",
    uv: 12780,
    pv: 3908,
    amt: 4100,
  },
  {
    month: "May",
    uv: 18900,
    pv: 4800,
    amt: 1181,
  },
  {
    month: "Jun",
    uv: 1890,
    pv: 4800,
    amt: 19181,
  },
  {
    month: "July",
    uv: 18900,
    pv: 4800,
    amt: 11181,
  },
  {
    month: "Aug",
    uv: 8900,
    pv: 4800,
    amt: 2081,
  },
  {
    month: "Sep",
    uv: 11890,
    pv: 4800,
    amt: 4181,
  },
  {
    month: "Oct",
    uv: 5990,
    pv: 4800,
    amt: 6181,
  },
  {
    month: "Nov",
    uv: 13390,
    pv: 4800,
    amt: 21181,
  },
  {
    month: "Dec",
    uv: 4890,
    pv: 4800,
    amt: 7181,
  },
];

export const userRows = [
  {
    id: 1,
    avatar:
      "https://images.unsplash.com/photo-1534528741775-53994a69daeb?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=700&q=80",
    user: "Snow",
    email: "tomi22@gmail.com",
    transaction: "$1000",
  },
  {
    id: 2,
    avatar:
      "https://images.unsplash.com/photo-1534528741775-53994a69daeb?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=700&q=80",
    user: "Lannister",
    email: "tomi22@gmail.com",
    transaction: "$200",
  },
  {
    id: 3,
    avatar:
      "https://images.unsplash.com/photo-1534528741775-53994a69daeb?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=700&q=80",
    user: "Lannister",
    email: "tomi22@gmail.com",
    transaction: "$500",
  },
  {
    id: 4,
    avatar:
      "https://images.unsplash.com/photo-1534528741775-53994a69daeb?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=700&q=80",
    user: "Stark",
    email: "tomi22@gmail.com",
    transaction: "$5000",
  },
  {
    id: 5,
    avatar:
      "https://images.unsplash.com/photo-1534528741775-53994a69daeb?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=700&q=80",
    user: "Targaryen",
    email: "tomi22@gmail.com",
    transaction: "$1000",
  },
  {
    id: 6,
    avatar:
      "https://images.unsplash.com/photo-1534528741775-53994a69daeb?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=700&q=80",
    user: "Melisandre",
    email: null,
    transaction: "$50",
  },
  {
    id: 7,
    avatar:
      "https://images.unsplash.com/photo-1534528741775-53994a69daeb?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=700&q=80",
    user: "Clifford",
    email: "tomi22@gmail.com",
    transaction: "$2000",
  },
  {
    id: 8,
    avatar:
      "https://images.unsplash.com/photo-1534528741775-53994a69daeb?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=700&q=80",
    user: "Frances",
    email: "tomi22@gmail.com",
    transaction: "$10000",
  },
  {
    id: 9,
    avatar:
      "https://images.unsplash.com/photo-1534528741775-53994a69daeb?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=700&q=80",
    user: "Roxie",
    email: "tomi22@gmail.com",
    transaction: "$300",
  },
];
